import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type TransformNodeType = Node<NodeData, 'custom_transform'>;

export const TransformNode: React.FC<NodeProps<TransformNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const subtitle = 'Transform';

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="transform"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Single input handle */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="data"
        blockId={id}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'data'))
            : undefined
        }
      />
      {/* Single output handle */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id="transformed_data"
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
